import { useAccountStore } from '@/store/use-account-store';
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { FilledOrder, useOrdersStore } from '@/store/use-orders-store';
import { cn } from '@/utils/cn';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  orderId: string;
};

export default function Fee({ orderId }: Props) {
  const address = useAccountStore((state) => state.address);
  const fee = useOrdersStore(
    (state) => (state.getOrders(address).orders[orderId] as FilledOrder).fees,
  );
  return (
    <span className={cn(!fee && 'text-vestgrey-100')}>
      {formatBigInt(fee, COLLATERAL_DECIMALS, { digits: 2, round: 'ceil' })}
    </span>
  );
}

export const feeAccessorFn = (id: string) => {
  const { address } = useAccountStore.getState();
  const { fees } = useOrdersStore.getState().getOrders(address).orders[
    id
  ] as FilledOrder;

  const feeNum = bigIntToNum(fees, COLLATERAL_DECIMALS);

  return Number.isNaN(feeNum) ? undefined : feeNum;
};
